import React from 'react'
import { connect } from 'react-redux'
import { selectItems } from '../actions/lists'

function mapStateToProps(state, props) {
    const { entities: salesLeadEntities, result, isFetching, filters } = state.salesLeads
    const filter = filters[props.filterId]
    const searchKey = filter && filter.searchKey

    return {
        salesLeadEntities,
        pages: result[searchKey] || {},
        filter,
        isFetching,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        select: (ids, filterId) => dispatch(selectItems('salesLeads', ids, filterId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
